import createCompressor from 'redux-persist-transform-compress'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export default (reducerKey, reducer, blocklist = [], allowlist = []) => {
  let version = 4

  if (reducerKey === 'userSessionManager') {
    version = 3
  }

  const compressor = createCompressor()
  const config = {
    blacklist: blocklist, // maintain compatibility with redux-persist API
    key: reducerKey,
    migrate: (state, version) => {
      const migrationState = state?._persist?.version !== version ? null : state

      return Promise.resolve(migrationState)
    },
    storage,
    transforms: [compressor],
    version,
    whitelist: allowlist, // maintain compatibility with redux-persist API
  }

  return persistReducer(config, reducer)
}
